module.exports = __webpack_public_path__ + "static/media/google-button-over.4ba29f79.svg";